import { configureStore } from "@reduxjs/toolkit";

import auth, { AuthState } from "store/auth";
import config, { ConfigState } from "store/config";
import misionVision, { MissionVisionState } from "store/mision-vision";
import about, { AboutState } from "store/about";
import servicePrice, { ServicePriceState } from "store/service-price";
import role, { RoleState } from "store/role";
import department, { DepartmentState } from "store/department";
import position, { PositionState } from "store/position";
import specialty, { SpecialtyState } from "store/specialty";
import permission, { PermissionState } from "store/permission";
import user, { UserState } from "store/user";
import topic, { TopicState } from "store/topic";
import post, { PostState } from "store/post";
import timeFrame, { TimeFrameState } from "store/time-frame";
import booking, { BookingState } from "store/booking";
import service, { ServiceState } from "store/service";
import message, { MessageState } from "store/message";
import folder, { FolderState } from "store/folder";
import file, { FileState } from "store/file";
import notification, { NotificationState } from "store/notification";

export const store = configureStore({
  reducer: {
    auth,
    config,
    about,
    misionVision,
    servicePrice,
    role,
    department,
    position,
    specialty,
    permission,
    user,
    topic,
    post,
    timeFrame,
    booking,
    service,
    message,
    folder,
    file,
    notification
  },
});

export interface RootState {
  auth: AuthState;
  config: ConfigState;
  about: AboutState;
  misionVision: MissionVisionState;
  servicePrice: ServicePriceState;
  role: RoleState;
  department: DepartmentState;
  position: PositionState;
  specialty: SpecialtyState;
  permission: PermissionState;
  user: UserState;
  topic: TopicState;
  post: PostState;
  timeFrame: TimeFrameState;
  booking: BookingState;
  service: ServiceState;
  message: MessageState;
  folder: FolderState;
  file: FileState;
  notification: NotificationState;
}
export type AppDispatch = typeof store.dispatch;
